var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCkChevronDown = function SvgCkChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.56 5.72668L8.5 8.78002L5.44 5.72668L4.5 6.66668L8.5 10.6667L12.5 6.66668L11.56 5.72668Z",
    fill: "white"
  })));
};
export { SvgCkChevronDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjU2IDUuNzI2NjhMOC41IDguNzgwMDJMNS40NCA1LjcyNjY4TDQuNSA2LjY2NjY4TDguNSAxMC42NjY3TDEyLjUgNi42NjY2OEwxMS41NiA1LjcyNjY4WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";